import React, { createContext, useContext, useMemo, useSyncExternalStore } from 'react';

// Relative imports (not the `utils/` alias) so jest can resolve them
import { createScreenContextRegistry } from '../../utils/situationalAwareness';
import { jsx as _jsx } from "react/jsx-runtime";
var SituationalAwarenessContext = /*#__PURE__*/createContext(null);
function SituationalAwarenessProvider(_ref) {
  var children = _ref.children;
  var registry = useMemo(createScreenContextRegistry, []);
  return /*#__PURE__*/_jsx(SituationalAwarenessContext.Provider, {
    value: registry,
    children: children
  });
}

/**
 * The descriptors currently on the user's screen, in the order they became
 * visible, updated as components register and unregister via
 * `useVisibleScreenContext`. This is what agent integrations send as
 * situational awareness. Must be used inside a SituationalAwarenessProvider.
 *
 * @returns The current screen context descriptors
 */
function useCurrentScreenContexts() {
  var registry = useContext(SituationalAwarenessContext);
  if (!registry) {
    throw Error('useCurrentScreenContexts must be used inside a SituationalAwarenessProvider');
  }
  return useSyncExternalStore(registry.subscribe, registry.getContexts);
}
export { SituationalAwarenessContext, SituationalAwarenessProvider, useCurrentScreenContexts };